
const splitWords = (el, newClass = "letterize") => {
    el.innerHTML = el.textContent.replace(/\S+/g, `<span class='${newClass}'>$&</span>`);
};

const splitChars = (str, newClass = "chars") => {
    str.innerHTML = str.innerHTML.replace(/\w/g, `<span class='${newClass}' style="display: inline-block;">$&</span>`);
};

export { splitWords, splitChars };